<template>
  <div class="dialog-size-md mp-international-publishing-status-dialog">
    <div class="modal-body">
      <h2>
        {{ $t('DESIGNS.DETAILS.MP_INTPUB.HEADING') }}
      </h2>
      <p class="text-grey">
        {{ $t('DESIGNS.DETAILS.MP_INTPUB.SUBHEADING') }}
      </p>

      <div v-if="isInstantlyPublished" class="color-box">
        {{ $t('DESIGNS.DETAILS.MP_KIDS_INFO') }}
      </div>

      <CompositionPublishingStatusTable
        :get-deeplink-for-locale="getDeeplinkForLocale"
        display-unavailable-deeplinks
        :is-instantly-published="isInstantlyPublished"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import mpUrlService from 'commons/api/mpUrlService/mpUrlService';
import CompositionPublishingStatusTable from '../CompositionPublishingStatusTable.vue';
import {
  COMPOSITION_POS_TYPES,
  isInstantlyPublished,
} from 'commons/api/models/publishingCore/compositionPosStates';
import { useCompositionStore } from 'commons/stores/composition';

export default {
  name: 'PublishingMpPreviewDialog',
  components: {
    CompositionPublishingStatusTable,
  },
  props: ['modalInstance', 'data'],
  computed: {
    ...mapState(useCompositionStore, {
      composition: (store) => store.current,
    }),
    isInstantlyPublished() {
      return isInstantlyPublished(this.composition, COMPOSITION_POS_TYPES.MP);
    },
  },
  methods: {
    getDeeplinkForLocale(locale) {
      return mpUrlService.getMpDeeplink(this.composition.id, {
        locale,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/type';

.mp-international-publishing-status-dialog {
  .modal-body {
    & > h2 {
      margin: 0;
    }

    & > p {
      margin: 12px 0 16px 0;
    }
  }
}

.loading-wrapper {
  margin: 48px 0;
}
</style>
